// Layout breakpoints used from JS (the same widths appear in the CSS media queries).

export const MEDIA = {
  /** below this the navigation rail becomes a drawer (phones, tablets in portrait) = shell.css */
  drawer: '(max-width: 1023px)',
  /** the overview's panels float over a full-height map from here on (enough map stays visible between them);
   * below they stack under it = overview.css */
  commandFloating: '(min-width: 1280px) and (min-height: 600px)',
  /** phones (and phones turned sideways, too short for a popup with a calendar): a list's filter menus fold into
   * one "Filter" button and a bottom sheet = filter-menu.css, audit.css */
  filterSheet: '(max-width: 640px), (max-height: 480px)',
  /** a touch screen: a small map inside a scrolling form leaves one-finger swipes to the page (two fingers move it) */
  coarse: '(pointer: coarse)',
} as const;

/** Gap between the overview's floating panels and the edge of the map (px) = --cc-gap in overview.css. */
export const COMMAND_GAP = 16;
/** the round "open the panel" button that replaces the collapsed side panel (= .cc-side-fab) */
export const COMMAND_SIDE_FAB = 56;
/** the overview's "Alur distribusi" panel (= .cc-flow) and the navigation rail beside the page (= shell.css), for the
 * collapsed-by-default rule: the panel starts folded when the map's free width at the national view would be less
 * than `minFreeMap` with it open */
export const COMMAND_FLOW = { width: 380, navRail: 64, sideMin: 380, sideMax: 430, sideShare: 0.28, minFreeMap: 900 } as const;

/** The red badge drawn on the tab icon while critical alerts are open (canvas px of a 64 px icon). */
export const FAVICON_BADGE = { size: 64, radius: 19, ring: 3, font: 26, fontSmall: 20 } as const;

/** A popup menu is at least this wide (= .menu.photo-menu); one that would leave the screen opens the other way. */
export const MENU_MIN_WIDTH = 210;
/** Room kept between a popup and the edge of the screen (px). */
export const SCREEN_EDGE_GAP = 16;
/** A horizontal swipe longer than this (px), and more sideways than up or down, turns the page (photo viewer). */
export const SWIPE_MIN_PX = 48;

/** Filter popups (ui/FilterMenu): width, gap under the button, and the least height kept when the button sits low. */
export const FILTER_MENU = { width: 280, wideWidth: 320, offset: 6, minHeight: 220 } as const;
